
export default {
  name: 'AppCarousel',
  props: {
    images: {
      type: Array,
      required: true
    }
  }
}
